import * as React from 'react';

function CircledBackArrow(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" {...props}>
      <path
        d="M23 12.7162C23.0003 12.9417 22.953 13.165 22.8608 13.3732C22.7686 13.5815 22.6334 13.7707 22.4628 13.9298L17.1853 19.0167L22.4628 24.0909C22.7968 24.4146 22.9816 24.8483 22.9774 25.2983C22.9732 25.7484 22.7804 26.179 22.4405 26.4972C22.1006 26.8155 21.6408 26.996 21.1601 26.9999C20.6794 27.0038 20.2163 26.8308 19.8705 26.5181L12 19.0167L19.8705 11.5026C20.1269 11.2626 20.4535 11.0992 20.8091 11.033C21.1647 10.9668 21.5332 11.0008 21.8682 11.1306C22.2031 11.2605 22.4894 11.4805 22.6909 11.7627C22.8924 12.045 22.9999 12.3768 23 12.7162Z"
        fill="#202020"
      />
      <circle cx="19" cy="19" r="18.5" stroke="currentColor" />
    </svg>
  );
}

const MemoCircledBackArrow = React.memo(CircledBackArrow);
export default MemoCircledBackArrow;
